import { render, staticRenderFns } from "./ItemIcon.vue?vue&type=template&id=6b6c2116&scoped=true&"
import script from "./ItemIcon.vue?vue&type=script&lang=js&"
export * from "./ItemIcon.vue?vue&type=script&lang=js&"
import style0 from "./ItemIcon.vue?vue&type=style&index=0&id=6b6c2116&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6c2116",
  null
  
)

export default component.exports